import catalog from "@/generated/customerPlans.json";

export const customerPlans = catalog.plans;
export const planManagedFlags = catalog.managed_flags;

export function planPreviewOverrides(existing, planID) {
    const plan = customerPlans.find((item) => item.id === planID);
    if (!plan) throw new Error("Unknown plan preview");
    const enabled = new Set(plan.feature_flags);
    const result = { ...existing };
    for (const flag of planManagedFlags) result[flag] = enabled.has(flag);
    return result;
}

export function restorePlanPreview(existing) {
    const result = { ...existing };
    for (const flag of planManagedFlags) delete result[flag];
    return result;
}

// Explicit plans opt into module-scoped reports; legacy access stays unchanged.
export function usesPlanFeatureScope(client, overrides) {
    return !!(
        client?.feature_profile_id ||
        client?.billing_plan_id ||
        (overrides?.active && overrides?.planPreviewID)
    );
}
